export default __webpack_public_path__ + "static/Natural_Light_Outdoor_640kbps-78789ac3134998c222ae4eca33fdb110.avif";